
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/open/login",
      function () {
        return require("private-next-pages/open/login.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/open/login"])
      });
    }
  